export default "__VITE_ASSET__4bec8841__"